if (!customElements.get('product-form')) {
  customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener(
					"submit",
					this.onSubmitHandler.bind(this)
				);
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			async onSubmitHandler(evt) {
				evt.preventDefault();
				// From here on: Single product (non-bundle) form submission
				if (this.submitButton.getAttribute("aria-disabled") === "true")
					return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				this.querySelector(
					".loading-overlay__spinner"
				).classList.remove("hidden");
				// Check if we're submitting a bundle
				if (this.form.dataset.bundle) {
					console.log("isBundle");

					const productForms = document.querySelectorAll(
						".bundle_product-select-container form.form"
					);

					if (productForms.length > 0) {
						// Submit all bundle item forms one by one
						for (const form of productForms) {
							const formData = new FormData(form);

							try {
								const response = await fetch("/cart/add.js", {
									method: "POST",
									body: formData,
									headers: {
										Accept: "application/json",
									},
								});

								if (!response.ok) {
									throw new Error(
										"Add to cart failed for a bundle product"
									);
								}

								const data = await response.json();
								console.log(`Added bundle item: ${data.title}`);
							} catch (error) {
								console.error(error);
								return; // Stop everything if any bundle form fails
							}
						}

						// ✅ Once all bundle items are added, exit here.
						// Do NOT continue submitting `this.form` afterward.
						// return;
					}
				}

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						"sections",
						this.cart
							.getSectionsToRender()
							.map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: "product-form",
								productVariantId: formData.get("id"),
								errors: response.description,
								message: response.message,
							});
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(
									".sold-out-message"
								);
							if (!soldOutMessage) return;
							this.submitButton.setAttribute(
								"aria-disabled",
								true
							);
							this.submitButton
								.querySelector("span")
								.classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: "product-form",
								productVariantId: formData.get("id"),
							});
						this.error = false;

						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
										document.dispatchEvent(
											new CustomEvent("Cart:Updated")
										);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
							document.dispatchEvent(
								new CustomEvent("Cart:Updated")
							);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (
							this.cart &&
							this.cart.classList.contains("is-empty")
						)
							this.cart.classList.remove("is-empty");
						if (!this.error)
							this.submitButton.removeAttribute("aria-disabled");
						this.querySelector(
							".loading-overlay__spinner"
						).classList.add("hidden");

						const bundleContainer = document.querySelector(".bundle_product-select-container");

						if (bundleContainer) {
							fetch(window.location.href)
								.then(response => response.text())
								.then(htmlText => {
								const parser = new DOMParser();
								const doc = parser.parseFromString(htmlText, "text/html");

								// Find all selects in the current container
								const currentSelects = bundleContainer.querySelectorAll('[id*="bundle_product-select-"]');

								currentSelects.forEach((currentSelect, index) => {
									// Match the corresponding select from fetched page
									const fetchedSelect = doc.querySelector(`#bundle_product-select-${index + 1}`);
									if (!fetchedSelect) return;

									const currentOptions = currentSelect.querySelectorAll("option");
									const fetchedOptions = fetchedSelect.querySelectorAll("option");

									currentOptions.forEach((option, i) => {
									const fetchedOption = fetchedOptions[i];
									if (!fetchedOption) return;

									// ✅ Update inventory
									const inventory = fetchedOption.dataset.inventory || "0";
									option.dataset.inventory = inventory;

									// ✅ Disable if inventory is 0
									if (parseInt(inventory, 10) === 0) {
										option.disabled = true;
									} else {
										option.disabled = false;
									}
									});
								});

								console.log("Bundle select options updated with inventory & disabled state.");
								})
							.catch(error => console.error("Error fetching page:", error))
							.finally(() => {
								initializeBundleSelects();
							})

							function initializeBundleSelects() {
								const selects = Array.from(document.querySelectorAll(".bundle_product-select"));
								if (!selects.length) return;

								// Build inventory map from the first select's options
								const inventoryMap = {};
								selects[0].querySelectorAll("option").forEach(option => {
								const inv = parseInt(option.dataset.inventory || "0", 10);
								inventoryMap[option.value] = inv;
								});

								// Helper: update image for a given select
								function updateBundleImage(select, index) {
									const selectedOption = select.options[select.selectedIndex];
									const imgSrc = selectedOption?.dataset.image;
									const imgEl = document.querySelector(`#bundle_product-image-${index + 1}`);
									if (imgEl && imgSrc) {
										imgEl.src = imgSrc;
									}
								}

								// Helper: disable out-of-stock options
								function updateDisabledStates() {
									selects.forEach(select => {
										Array.from(select.options).forEach(option => {
										option.disabled = inventoryMap[option.value] <= 0;
										});
									});
								}

								// Initialize each select
								selects.forEach((select, index) => {
									let chosen = null;
									const current_selected = document.querySelector(`#${select.id} option[selected]`);

									if (current_selected && inventoryMap[current_selected.value] > 0) {
										chosen = current_selected.value;
									}else{
										for (let option of select.options) {
											if (inventoryMap[option.value] > 0) {
											chosen = option.value;
											break;
											}
										}
									}

									if (chosen) {
										select.value = chosen;
										select.dispatchEvent(new Event("change", { bubbles: true }));
										inventoryMap[chosen] -= 1;
										updateBundleImage(select, index);
									}

									// Update image when user changes selection
									select.addEventListener("change", () => {
										updateBundleImage(select, index);
									});
								});

								// Disable options with 0 inventory
								updateDisabledStates();
							}
							initializeBundleSelects();
						}

					});
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute(
					"hidden",
					!errorMessage
				);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
  );
}

class stickyCartModal extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('scroll', this.update.bind(this));
    this.update();
    document.querySelector('.footer__content').classList.add('sticky-cart-modal_bottom_padding');
    this.querySelector('.sticky-cart-button').addEventListener('click', this.onClickHandler.bind(this));
    this.querySelector('.sticky-cart-button').addEventListener('keydown', this.onClickKeydownHandler.bind(this));
  }
  update(){
    const button = document.getElementById(`product-form-${this.dataset.section}`);
	const addButton = button.querySelector('[name="add"]');
    const rangeToShowModal = this.getTop(addButton) + addButton.clientHeight;
    if(window.scrollY >= rangeToShowModal && !this.classList.contains('show-modal')){
      this.classList.add('show-modal');
      document.querySelector('body').classList.add('modal__sticky-cart');
    }
    if(window.scrollY < rangeToShowModal && this.classList.contains('show-modal')){
      this.classList.remove('show-modal');
      document.querySelector('body').classList.remove('modal__sticky-cart');
    }
  }
  onClickKeydownHandler(){
    if(event.code.toUpperCase() !== 'ENTER') return false;
    this.onClickHandler();
  }
  onClickHandler(){
    var item = document.getElementById("variants-container"),
        btn_item = document.getElementById("product-container"),
        _y = item ? this.getTop(item) : this.getTop(btn_item);
    this.scrollTo(_y,700);
  }
  getTop(el) {
    return el.offsetTop + (el.offsetParent && this.getTop(el.offsetParent));
  }
  scrollTo(to, duration) {
    const element = document.scrollingElement || document.documentElement,
          start = element.scrollTop,
          change = to - start,
    animateScroll = function() {
      element.scrollTop = to;
    };
    animateScroll();
  }
}
customElements.define('sticky-cart-modal', stickyCartModal);

